import Company from './components/Company';
import { CreditApplicationType } from 'src/utils/enums/financialTypes.enum';
import FormSectionPage from '../../ui/formSectionPage';
import Income from './components/Income';
import { useLocalization } from 'src/utils/useLocalization';
import {
    ADDRESS_NUMBER,
    ADDRESS_NUMBER2,
    validateCompanyName,
    validateJobMonth,
    validateJobYear,
    validateLengthNumber,
    validateRequired,
    validateZipCanada,
    validateZipUSA,
} from '../utils';
import { NUMBER_TWO, NUMBER_ZERO } from 'src/utils/constants';
import { useEffect, useState } from 'react';

export interface IIncome {
    type: string;
    frequency: string;
    amount: number | null;
    error?: boolean;
}

export interface IOccupation {
    retired: boolean;
    employed: boolean;
    selfEmployed: boolean;
    city: string;
    country: string;
    province: string;
    code: string;
    occupation: string;
    jobYear: number | null;
    jobMonth: number | null;
    address: string;
    addressSecondary: string;
    company: string;
    setErrorCompany: Function;
    setErrorAddress: Function;
    setErrorAddressSecondary: Function;
    setErrorCity: Function;
    setErrorCode: Function;
    setErrorOcuppation: Function;
    setErrorJobYear: Function;
    setErrorJobMonth: Function;
    preCity: string;
    preCountry: string;
    preProvince: string;
    preCode: string;
    preOccupation: string;
    preJobYear: number;
    preJobMonth: number;
    preAddress: string;
    preAddressSecondary: string;
    preCompany: string;
    setErrorPreCompany: Function;
    setErrorPreAddress: Function;
    setErrorPreAddressSecondary: Function;
    setErrorPreCity: Function;
    setErrorPreCode: Function;
    setErrorPreOcuppation: Function;
    setErrorPreJobYear: Function;
    setErrorPreJobMonth: Function;
}

interface IProps {
    applicationType: string;
    setIncomeData: Function;
    setOccupationData: Function;
    setIncomeValid: Function;
    isOpen: boolean;
    setOpen: Function;
    isBlocked?: boolean;
    initialJointOrCoApplicant?: any;
    isEditMode?: boolean;
    disablePrintAndSubmitBtn: Function;
}

export const oc: IOccupation = {
    occupation: '',
    company: '',
    address: '',
    addressSecondary: '',
    city: '',
    country: 'USA',
    province: '',
    code: '',
    jobMonth: null,
    jobYear: null,
    retired: false,
    employed: false,
    selfEmployed: false,
    setErrorCompany: () => {
        return;
    },
    setErrorAddress: () => {
        return;
    },
    setErrorAddressSecondary: () => {
        return;
    },
    setErrorCity: () => {
        return;
    },
    setErrorCode: () => {
        return;
    },
    setErrorOcuppation: () => {
        return;
    },
    setErrorJobYear: () => {
        return;
    },
    setErrorJobMonth: () => {
        return;
    },
    preOccupation: '',
    preCompany: '',
    preAddress: '',
    preAddressSecondary: '',
    preCity: '',
    preCountry: 'USA',
    preProvince: '',
    preCode: '',
    preJobMonth: 0,
    preJobYear: 0,
    setErrorPreCompany: () => {
        return;
    },
    setErrorPreAddress: () => {
        return;
    },
    setErrorPreAddressSecondary: () => {
        return;
    },
    setErrorPreCity: () => {
        return;
    },
    setErrorPreCode: () => {
        return;
    },
    setErrorPreOcuppation: () => {
        return;
    },
    setErrorPreJobYear: () => {
        return;
    },
    setErrorPreJobMonth: () => {
        return;
    },
};

const BusinessCoApp = ({
    applicationType,
    setIncomeData,
    setOccupationData,
    setIncomeValid,
    isOpen,
    setOpen,
    isBlocked = false,
    initialJointOrCoApplicant = false,
    isEditMode = false,
    disablePrintAndSubmitBtn,
}: IProps) => {
    const { businessComercial } = useLocalization();
    const [incomes, setIncomes] = useState<IIncome[]>([]);
    const [occupationObject, setOccupationObject] = useState<IOccupation>(oc);
    const [validated, setValidated] = useState<boolean | null>(null);
    const [isIncomeSubmitted, setIsIncomeSubmitted] = useState<boolean>(false);
    const [disabledFormIncome, setDisabledFormIncome] =
        useState<boolean>(false);
    const [isCoAppIncomeFieldValueUpdated, setIsCoAppIncomeFieldValueUpdated] =
        useState<boolean>(false);
    const [
        isCoAppOccupationFieldValueUpdated,
        setIsCoAppOccupationFieldValueUpdated,
    ] = useState<boolean>(false);

    function handlerChangeIncomes(value: any) {
        setIncomes(value.incomes);
    }

    function handlerChangeCompany(values: any) {
        setOccupationObject({ ...values });
    }

    function buildAndSetIncomeAndOccupationData() {
        setIncomeData(
            incomes.map((income) => {
                return {
                    typeOfIncome: income.type,
                    grossIncomeAmt: income.amount,
                    incomeFrequency: income.frequency,
                };
            }),
        );

        let addressLine2;

        if (occupationObject.addressSecondary.trim()) {
            addressLine2 = occupationObject.addressSecondary.trim();
        }

        let address;

        if (
            occupationObject.address.trim() &&
            occupationObject.city.trim() &&
            occupationObject.code.trim()
        ) {
            address = {
                addressLine1: occupationObject.address.trim(),
                addressLine2,
                city: occupationObject.city.trim(),
                zipOrPostalCode: occupationObject.code.toUpperCase().trim(),
                state: occupationObject.province,
                country: occupationObject.country == 'USA' ? 'US' : 'CA',
            };
        }

        let employerName;

        if (occupationObject.company.trim()) {
            employerName = occupationObject.company.trim();
        }

        let occupation;

        if (occupationObject.occupation.trim()) {
            occupation = occupationObject.occupation.trim();
        }

        const employerData: any = {
            current: {
                address,
                employerName,
                occupation,
                employmentType: selectEmploymentType(occupationObject),
                timeAtJob: {
                    timeOnJobsMonths: occupationObject.jobMonth || NUMBER_ZERO,
                    timeOnJobsYears: occupationObject.jobYear || NUMBER_ZERO,
                },
            },
        };
        // pre emp
        if (
            typeof occupationObject.jobYear === 'number' &&
            occupationObject.jobYear < NUMBER_TWO
        ) {
            let preAddressLine2;

            if (occupationObject.preAddressSecondary.trim()) {
                preAddressLine2 = occupationObject.preAddressSecondary.trim();
            }

            let preAddress;

            if (
                occupationObject.preAddress.trim() &&
                occupationObject.preCity.trim() &&
                occupationObject.preCode.trim()
            ) {
                preAddress = {
                    addressLine1: occupationObject.preAddress.trim(),
                    addressLine2: preAddressLine2,
                    city: occupationObject.preCity.trim(),
                    zipOrPostalCode: occupationObject.preCode
                        .toUpperCase()
                        .trim(),
                    state: occupationObject.preProvince,
                    country: occupationObject.preCountry == 'USA' ? 'US' : 'CA',
                };
            }

            let preEmployerName;

            if (occupationObject.preCompany.trim()) {
                preEmployerName = occupationObject.preCompany.trim();
            }

            let preOccupation;

            if (occupationObject.preOccupation.trim()) {
                preOccupation = occupationObject.preOccupation.trim();
            }
            employerData.previous = {
                address: preAddress,
                employerName: preEmployerName,
                occupation: preOccupation,
                timeAtJob: {
                    timeOnJobsMonths: occupationObject.preJobMonth,
                    timeOnJobsYears: occupationObject.preJobYear,
                },
                employmentType: employerData.current.employmentType,
            };
        }

        setOccupationData(employerData);
    }

    function handlerSubmitIncome() {
        setIsIncomeSubmitted(true);
        if (incomes.length) {
            if (!validaIncomes(incomes)) return;
        } else {
            setValidated(false);
        }

        const aux = validateOccupation(occupationObject);
        if (aux === false) {
            setValidated(false);
            return;
        }

        buildAndSetIncomeAndOccupationData();
        setValidated(true);
        setDisabledFormIncome(true);
        setOpen(false);
        setIncomeValid(true);
    }

    function selectEmploymentType(occpObject: IOccupation) {
        if (occpObject.retired && occpObject.selfEmployed)
            return 'SelfEmployedRetired';
        else if (occpObject.retired) return 'Retired';
        else if (occpObject.selfEmployed) return 'SelfEmployed';
        else return 'Employed';
    }

    function validateOccupation(value: IOccupation) {
        const {
            retired,
            city,
            country,
            code,
            occupation,
            jobYear,
            jobMonth,
            address,
            addressSecondary,
            company,
            setErrorCompany,
            setErrorAddress,
            setErrorAddressSecondary,
            setErrorCity,
            setErrorCode,
            setErrorOcuppation,
            setErrorJobYear,
            setErrorJobMonth,
            preCity,
            preCountry,
            preCode,
            preOccupation,
            preJobYear,
            preJobMonth,
            preAddress,
            preAddressSecondary,
            preCompany,
            setErrorPreCompany,
            setErrorPreAddress,
            setErrorPreAddressSecondary,
            setErrorPreCity,
            setErrorPreCode,
            setErrorPreOcuppation,
            setErrorPreJobYear,
            setErrorPreJobMonth,
        } = value;
        const validatePreviousEmployer =
            typeof jobYear === 'number' && jobYear < NUMBER_TWO;

        function validate(func: Function, value: string, top = Number('30')) {
            if (value?.length && value !== ' ') {
                const aux = validateLengthNumber(value.trim(), top);
                if (!aux) {
                    func(false);
                    return getTrue();
                } else {
                    func(true);
                    return false;
                }
            } else {
                func(true);
                return false;
            }
        }

        function validateFieldRequired(
            func: Function,
            value: string,
            top = Number('30'),
        ) {
            if (value) {
                const aux =
                    validateLengthNumber(value.trim(), top) ||
                    validateRequired(value.trim());
                if (!aux) {
                    func(false);
                    return getTrue();
                } else {
                    func(true);
                    return false;
                }
            } else {
                func(true);
                return false;
            }
        }

        function validateFieldOptional(
            func: Function,
            value: string,
            top = Number('30'),
        ) {
            if (!value.trim()) {
                func(false);
                return true;
            }
            return validate(func, value.trim(), top);
        }

        function validateZip(
            zipCountry: string,
            func: Function,
            value: string,
        ) {
            if (!value.trim()) {
                func(false);
                return true;
            }
            if (zipCountry.includes('USA')) {
                const aux = validateZipUSA(value);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            } else {
                const aux = validateZipCanada(value);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            }
        }

        function validateYear(func: Function, year: number) {
            if (year || year === Number('0')) {
                const aux = validateJobYear(year);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            } else {
                func(true);
                return false;
            }
        }

        function validateMonth(func: Function, month: number) {
            if (month || month === Number('0')) {
                const aux = validateJobMonth(month);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            } else {
                func(true);
                return false;
            }
        }

        const spectrum: any[] = [];
        const isCompanyValid = validateCompanyName(company);
        const isPreCompanyValid = validateCompanyName(preCompany);
        if (retired) {
            setErrorCompany(false);
            setErrorAddress(false);
            setErrorAddressSecondary(false);
            setErrorCity(false);
            setErrorOcuppation(false);
            setErrorCode(false);
            setErrorJobYear(false);
            setErrorJobMonth(false);
            if (company?.length && company !== ' ') {
                setErrorCompany(!isCompanyValid);
                spectrum.push(isCompanyValid);
            }

            if (address?.length && address !== ' ') {
                spectrum.push(
                    validate(setErrorAddress, address, ADDRESS_NUMBER),
                );
            }

            if (addressSecondary?.length && addressSecondary !== ' ') {
                spectrum.push(
                    validate(
                        setErrorAddressSecondary,
                        addressSecondary,
                        ADDRESS_NUMBER2,
                    ),
                );
            }

            if (city?.length && city !== ' ') {
                spectrum.push(validate(setErrorCity, city));
            }

            if (occupation?.length && occupation !== ' ') {
                spectrum.push(
                    validate(setErrorOcuppation, occupation, Number('20')),
                );
            }

            if (code?.length && code !== ' ') {
                let aux;
                if (country.includes('USA')) {
                    aux = validateZipUSA(code);
                } else {
                    aux = validateZipCanada(code);
                }
                if (aux) {
                    setErrorCode(true);
                    spectrum.push(false);
                } else {
                    setErrorCode(false);
                    spectrum.push(getTrue());
                }
            }

            if (jobYear) {
                const aux = validateJobYear(jobYear);
                if (aux) {
                    setErrorJobYear(true);
                    spectrum.push(false);
                } else {
                    setErrorJobYear(false);
                    spectrum.push(getTrue());
                }
            }

            if (jobMonth) {
                const aux = validateJobMonth(jobMonth);
                if (aux) {
                    setErrorJobMonth(true);
                    spectrum.push(false);
                } else {
                    setErrorJobMonth(false);
                    spectrum.push(getTrue());
                }
            }

            if (validatePreviousEmployer) {
                setErrorPreCompany(!isPreCompanyValid);
                spectrum.push(isPreCompanyValid);
                spectrum.push(
                    validateFieldOptional(
                        setErrorPreAddress,
                        preAddress,
                        ADDRESS_NUMBER,
                    ),
                );
                if (
                    preAddressSecondary?.length &&
                    preAddressSecondary !== ' '
                ) {
                    spectrum.push(
                        validate(
                            setErrorPreAddressSecondary,
                            preAddressSecondary,
                            ADDRESS_NUMBER2,
                        ),
                    );
                }
                spectrum.push(validateFieldOptional(setErrorPreCity, preCity));
                spectrum.push(
                    validate(
                        setErrorPreOcuppation,
                        preOccupation,
                        Number('20'),
                    ),
                );
                spectrum.push(
                    validateZip(preCountry, setErrorPreCode, preCode),
                );

                const fieldJobYear = validateJobYear(preJobYear);
                if (fieldJobYear) {
                    setErrorPreJobYear(true);
                    spectrum.push(false);
                } else {
                    setErrorPreJobYear(false);
                    spectrum.push(getTrue());
                }

                const fieldPreJobMonth = validateJobMonth(preJobMonth);
                if (fieldPreJobMonth) {
                    setErrorPreJobMonth(true);
                    spectrum.push(false);
                } else {
                    setErrorPreJobMonth(false);
                    spectrum.push(getTrue());
                }
            }
            const value = spectrum.find((ele) => ele === false);
            if (spectrum.length) return value === undefined ? true : value;
            else return true;
        } else {
            setErrorCompany(!isCompanyValid);
            const fieldCompany = isCompanyValid;
            const fieldAddress = validateFieldOptional(
                setErrorAddress,
                address,
                ADDRESS_NUMBER,
            );
            const fieldCity = validateFieldOptional(setErrorCity, city);
            const fieldOccupation = validateFieldRequired(
                setErrorOcuppation,
                occupation,
            );
            setErrorJobYear(validateRequired(jobYear));
            setErrorJobMonth(validateRequired(jobMonth));
            const fieldCode = validateZip(country, setErrorCode, code);
            const fieldYear =
                typeof jobYear === 'number' &&
                !validateRequired(jobYear) &&
                validateYear(setErrorJobYear, jobYear);
            const fieldMonth =
                typeof jobMonth === 'number' &&
                !validateRequired(jobMonth) &&
                validateMonth(setErrorJobMonth, jobMonth);

            const validCurrentEmployer =
                fieldCompany &&
                fieldAddress &&
                fieldOccupation &&
                fieldMonth &&
                fieldCity &&
                fieldCode &&
                fieldYear;

            if (validatePreviousEmployer) {
                setErrorPreCompany(!isPreCompanyValid);
                const fieldPreCompany = isPreCompanyValid;
                const fieldPreAddress = validateFieldOptional(
                    setErrorPreAddress,
                    preAddress,
                    ADDRESS_NUMBER,
                );
                const fieldPreCity = validateFieldOptional(
                    setErrorPreCity,
                    preCity,
                );
                const fieldPreOccupation = validateFieldRequired(
                    setErrorPreOcuppation,
                    preOccupation,
                );
                const fieldPreCode = validateZip(
                    preCountry,
                    setErrorPreCode,
                    preCode,
                );
                const fieldPreYear =
                    !validateRequired(preJobYear) &&
                    validateYear(setErrorPreJobYear, preJobYear);
                const fieldPreMonth =
                    !validateRequired(preJobMonth) &&
                    validateMonth(setErrorPreJobMonth, preJobMonth);

                const validPreviousEmployer =
                    fieldPreCompany &&
                    fieldPreAddress &&
                    fieldPreOccupation &&
                    fieldPreMonth &&
                    fieldPreCity &&
                    fieldPreCode &&
                    fieldPreYear;

                return validCurrentEmployer && validPreviousEmployer;
            }
            return validCurrentEmployer;
        }
    }

    function getTrue() {
        setValidated(true);
        return true;
    }

    function validaIncomes(values: IIncome[]) {
        for (const i of values) {
            if (i.error || i.amount === null) {
                setValidated(false);
                return false;
            }
        }
        return true;
    }

    const onEdit = () => {
        setDisabledFormIncome(false);
        setIncomeValid(false);
        if (isEditMode) {
            disablePrintAndSubmitBtn(true);
        }
    };

    useEffect(() => {
        if (
            isEditMode &&
            isCoAppIncomeFieldValueUpdated &&
            isCoAppOccupationFieldValueUpdated
        ) {
            buildAndSetIncomeAndOccupationData();
        }
    }, [
        isEditMode,
        isCoAppIncomeFieldValueUpdated,
        isCoAppOccupationFieldValueUpdated,
    ]);

    return (
        <FormSectionPage
            title={
                applicationType === CreditApplicationType.BUSINESS_COAPP
                    ? businessComercial.CO_APP_INCOME
                    : businessComercial.GUARANTOR_APP_INCOME
            }
            handlerSubmit={handlerSubmitIncome}
            isOpen={isOpen}
            setOpen={setOpen}
            showIcon={validated}
            isDisabled={disabledFormIncome}
            onEdit={onEdit}
            isEditMode={isEditMode}
            isBlocked={isBlocked}
            disablePrintAndSubmitBtn={disablePrintAndSubmitBtn}
        >
            <fieldset disabled={disabledFormIncome}>
                <Income
                    key={'Income'}
                    handlerChangeItems={handlerChangeIncomes}
                    isDisabled={disabledFormIncome}
                    incomeError={isIncomeSubmitted}
                    initialIncomes={
                        initialJointOrCoApplicant?.Incomes?.value ?? null
                    }
                    isEditMode={isEditMode}
                    setFieldValueUpdated={setIsCoAppIncomeFieldValueUpdated}
                ></Income>
                <Company
                    key={'Company'}
                    handlerChange={handlerChangeCompany}
                    isDisabled={disabledFormIncome}
                    initialPrimaryApplicant={initialJointOrCoApplicant ?? null}
                    isEditMode={isEditMode}
                    setFieldValueUpdated={setIsCoAppOccupationFieldValueUpdated}
                ></Company>
            </fieldset>
        </FormSectionPage>
    );
};

export default BusinessCoApp;
